export enum ServiceOrganizationRole {
    dietetics = 'dietetics',
    hospital = 'hospital',
    lifestyleCoaching = 'lifestyleCoaching',
    policlinic = 'policlinic',
    psychology = 'psychology',
}
